import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdbe3ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group" }
const _hoisted_2 = { class: "group__img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "group__description" }
const _hoisted_5 = { class: "group__info" }
const _hoisted_6 = { class: "group__name" }
const _hoisted_7 = { class: "group__about" }
const _hoisted_8 = {
  key: 0,
  class: "members"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "members__number" }, "There are no members in this group", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "members-wrapper"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "members__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGroupClick && _ctx.onGroupClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.groupImg,
          alt: "profile"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userData.name), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userData.info), 1)
        ]),
        (_ctx.userData.members.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.members, (member, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: member,
                  class: "members"
                }, [
                  (index < 5)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getMemberPhoto(member.photo),
                        class: "icon-img",
                        alt: "icon"
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.userData.members.length) + " Members", 1)
            ]))
      ])
    ])
  ]))
}